
import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import GaranzieActions from './garanzie_actions';

import { Utils, DateFormatter, domain, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';


class RegimeFiscaleCreate extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[RegimeFiscaleCreate.jsx] ';
        this.state = {
            validation: new Map(),
            showConfirm: false,
            tipiAliquota: []
        };
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        // this.state = this.getInitalState();
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.salvaRF = this.salvaRF.bind(this);
        this.tipoAliquotaHandler = this.tipoAliquotaHandler.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.checkBoxChangeHandler = this.checkBoxChangeHandler.bind(this);

    }
    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        // if (!this.props.location || !this.props.location.state.modifica) {
        //     this.props.clearRF();
        // }
        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.getTipiAliquota(this.props.regimeFiscale.nomeEntity);
        } else {
            this.props.getTipiAliquota(this.props.location.state.nomeEntity);
        }
        this.props.handleChangeTipoAliquota("codTipoAliquota", this.props.regimeFiscale.codTipoAliquota);

    }
    cancelEdit() {
        this.props.history.push({ pathname: '/garanzie/details', state: { id: this.props.garanzia.id } });

    }
    showConfirmPanel() {
        this.setState({ showConfirm: !this.state.showConfirm });
        // $("#modalConfirm").modal("show");
    }
    validateForm() {
        let validation = new Map();
        let required = ['nome'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.regimeFiscale.nome === undefined || this.props.regimeFiscale.nome === '' || this.props.regimeFiscale.nome === null) {
                validation.set(required[0], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        // $("#modalConfirm").modal("close");
        this.setState({ showConfirm: !this.state.showConfirm });
        return false;
    }

    salvaRF() {
        // if (!this.validateForm()) {
        //     console.log('validateForm return false');
        //     return null;
        // }
        this.props.salvaRF(this.props.history);

        console.log("\salvaRF - end");
    }


    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;

            let type = e.target.type;
            if (type === "number" && value === "") {
                value = null;
            }

            this.props.handleChange(id, value);
        }
    }

    checkBoxChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            // let value = e.target.value;
            let id = e.target.id;
            this.props.handleChange("valoreAliquota", id);
        }
    }
    tipoAliquotaHandler(e) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            this.props.handleChangeTipoAliquota(id, value);
        }
    }

    render() {
        console.log(this.componentName + 'render');

        let tipiAliquota = [];
        let tipi = domain("AI_TIPO_ALIQUOTA");
        // for (let i = 0; i < tipi.length; i++) {
        //     let aliquata = {
        //         label: tipi[i],
        //         value: tipi[i]
        //     };
        //     tipiAliquota.push(aliquata);

        //     this.setState({ tipiAliquota: tipiAliquota })
        // }

        return (
            <div>
                <agui.aCardV4 className="mt-3 mb-3 inner-card">
                    <agui.aCardV4Header>
                        {this.props.location.state && this.props.location.state.modifica ?
                            <div className="col-md-6 col-sm-6 col-xs-6 " style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                {i18n('ARM_CORE_PRODUCT.GARANZIE.MODIFICA_REGIME_FISCALE_CON_ID', 'Modifica del Regime Fiscale con id')} {this.props.location.state.id}
                            </div>
                            :
                            <div className="col-md-6 col-sm-6 col-xs-6 " style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                {i18n('ARM_CORE_PRODUCT.GARANZIE.CREAZIONE_NUOVO_REGIME_FISCALE', 'Creazione Nuovo Regime Fiscale')}
                            </div>
                        }
                    </agui.aCardV4Header>
                    <agui.aCardV4Body>
                        <div>
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        {/* <dd className="col-sm-4 col-6">{this.props.regimeFiscale.nomeEntity} {this.props.regimeFiscale.idEntity}</dd> */}
                                        <agui.ATextInputV4 id="nomeEntity" type="text"
                                            value={this.props.regimeFiscale.nomeEntity + " " + this.props.regimeFiscale.idEntity}
                                            disabled={true}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.ENTITY', 'Entity')}
                                        />
                                    </div>
                                    {/* <dt className="col-sm-2 col-6">Desc Entity</dt> */}
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="descEntity" type="text"
                                            value={this.props.regimeFiscale.descEntity}
                                            disabled={true}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.DESC_ENTITY', 'Desc Entity')}
                                        />
                                    </div>
                                    {/* <dt className="col-sm-2
                                    <dd className="col-sm-4 col-6">{this.props.regimeFiscale.descEntity}</dd>
                                </div>} */}

                                </div>
                            }
                            <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ASelectV4
                                        id="codTipoAliquota"
                                        disabled={false}
                                        required={false}
                                        //classNameComponent="row"
                                        //classNameLabel="col-4"
                                        onChange={this.tipoAliquotaHandler}
                                        value={this.props.regimeFiscale.codTipoAliquota}
                                        label={i18n('ARM_CORE_PRODUCT.GARANZIE.TIPO_ALIQUOTA', 'Tipo Aliquota')}
                                        items={this.props.tipiAliquote}
                                        // {this.state.tipiAliquota}

                                        valueKey="valCampo"
                                        labelKey="desDom"
                                    />
                                </div>
                            </div>
                            {this.props.regimeFiscale.codTipoAliquota !== undefined
                                && this.props.regimeFiscale.codTipoAliquota !== null
                                && this.props.regimeFiscale.codTipoAliquota !== ""
                                &&
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <div className="row ml-1"> {i18n('ARM_CORE_PRODUCT.GARANZIE.VALORE_ALIQUOTA', 'Valore Aliquota')}
                                        </div>
                                        <div className="row mt-4">
                                            {
                                                this.props.valoriAliquote && this.props.valoriAliquote.map((item, index) =>
                                                    <div className="col col-sm-2 col-md-2 col-lg-2">
                                                        <agui.aToggleV4
                                                            id={item}
                                                            label={item}
                                                            type="radio"
                                                            // value =
                                                            checked={parseFloat(this.props.regimeFiscale.valoreAliquota).toFixed(2) === parseFloat(item).toFixed(2)}
                                                            onChange={this.checkBoxChangeHandler}
                                                        // value={this.props.regimeFiscale.valoreAliquota}
                                                        />
                                                    </div>

                                                )
                                            }
                                            {/* </div> */}
                                            {/* <div className="row"> */}
                                            {/* <div className="col col-sm-2 col-md-2 col-lg-2">
                                            <agui.aToggleV4
                                                id="altro"
                                                label="Altro"
                                                type="radio"
                                                checked={this.props.regimeFiscale.valoreAliquota === "altro"}
                                                onChange={this.checkBoxChangeHandler}
                                            />
                                        </div> */}
                                        </div>
                                        <div className="row  ml-1 mt-2">
                                            {/* <div className="col col-sm-2 col-md-2 col-lg-2">
                                            Altro
                                        </div> */}
                                            {/* <div className="col col-sm-10 col-md-10 col-lg-10"> */}
                                            {this.props.regimeFiscale && this.props.regimeFiscale.valoreAliquotaForzata &&
                                                <input type={"number"} className="form-control"
                                                    id="valoreAliquota" placeholder={i18n('ARM_CORE_PRODUCT.GARANZIE.INSERISCI_VALORE_ALIQUOTA', 'Inserisci valore Aliquota')}
                                                    // name={id} 
                                                    // visible={this.props.regimeFiscale && this.props.regimeFiscale.valoreAliquotaForzata}
                                                    value={this.props.regimeFiscale.valoreAliquota}
                                                    onChange={this.inputChangeHandler} />
                                            }
                                            {/* <agui.ATextInputV4 id="valoreAliquota" type="number"
                                            value={this.props.regimeFiscale.valoreAliquota}
                                            label=""
                                            disabled={this.props.regimeFiscale.valoreAliquota !== "altro"}
                                            placeholder="inserire valoreAliquota"
                                            onChange={this.inputChangeHandler} /> */}
                                            {/* </div> */}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">

                                    </div>
                                </div>}
                            {/* <div className="row mt-4">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="codRamo" type="text"
                                        value={this.props.regimeFiscale.codRamo}
                                        placeholder="inserire codice Ramo"
                                        required
                                        label={i18n('AI_RAMO_GARANZIA', 'Ramo Garanzia')}
                                        validation={this.state.validation}
                                        onChange={this.inputChangeHandler} />
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                    <agui.ATextInputV4 id="codBisogno" type="text"
                                        value={this.props.regimeFiscale.codBisogno}
                                        label={i18n('AI_BISOGNO', 'Bisogno')}
                                        placeholder="inserire codice Bisogno"
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div> */}
                        </div>
                        <br></br>

                    </agui.aCardV4Body>
                    <agui.aCardFooter>
                        <div>
                            <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.showConfirmPanel}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}</agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.cancelEdit}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCardV4 >
                <agui.ConfirmModalSaveV4
                    testoTitle = {i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoBody = {this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI.VOLER.SALV','Confermi di voler salvare?')}
                    testoButtonCancel = {i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    show={this.state.showConfirm}
                    saveOnClick={this.salvaRF}
                    onClose={this.showConfirmPanel} />
                {/* <agui.ConfirmModalV4 key="modalConfirm"
                    id="modalConfirm"
                    testo="Vuoi salvare la nuova garanzia ?"
                    titolo="Attenzione"
                    // pulsanteKO="No" pulsanteOK="Salva"
                    show={this.state.showConfirm}
                    okFunction={this.salvaGaranzia} /> */}

            </div >

        );
    }
};
function mapStateToProps(state) {
    return {
        regimeFiscale: state.garanzie.regimeFiscale,
        garanzia: state.garanzie.detailsGaranzia,
        valoriAliquote: state.garanzie.valoriAliquote,
        tipiAliquote: state.garanzie.tipiAliquote
    }
}

function mapDispatchToProps(dispatch) {
    return {

        salvaRF(history) {
            return dispatch(GaranzieActions.salvaRF(history));
        },
        handleChange(index, e) {
            return dispatch(GaranzieActions.handleChangeRF(index, e))
        },
        clearAll() {
            return dispatch(GaranzieActions.clearAll());
        },
        handleChangeTipoAliquota(index, value) {
            return dispatch(GaranzieActions.handleChangeTipoAliquota(index, value))
        },
        clearRF() {
            return dispatch(GaranzieActions.clearRF())
        },
        getTipiAliquota(nomeEntity) {
            return dispatch(GaranzieActions.getTipiAliquota(nomeEntity))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegimeFiscaleCreate);
